import { formikHelpers, lucideIcons, Tooltip } from '@round/creatorbase-ui';
import { useFormikContext } from 'formik';
import { ReactNode } from 'react';
import styles from './FieldWithError.module.css';

const { CircleAlertIcon } = lucideIcons;
const { shouldDisplayErrorMessage } = formikHelpers;

type Props = {
    name: string;
    children: ReactNode;
};

// Table cells have no room for an error line under the input, so the message sits behind an icon.
const FieldWithError = ({ name, children }: Props) => {
    const meta = useFormikContext().getFieldMeta(name);
    const error = shouldDisplayErrorMessage(meta) && typeof meta.error === 'string' ? meta.error : null;

    return (
        <div className={styles.container}>
            <div className={styles.field}>{children}</div>

            {error && (
                <Tooltip>
                    <Tooltip.Trigger type="button" className={styles.icon} aria-label={error}>
                        <CircleAlertIcon size={16} />
                    </Tooltip.Trigger>
                    <Tooltip.Content className={styles.content}>{error}</Tooltip.Content>
                </Tooltip>
            )}
        </div>
    );
};

export default FieldWithError;
